<template>
  <div
    class="row f-row col col-12 justify-content-center"
    style="height: 100%;"
  >
    <!-- Available assets -->
    <section class="col col 6 container__assets-selector">
      <div class="container__assets-selector--header">
        Available assets
      </div>
      <ul
        v-for="(list, i) in data.allDataList"
        :key="i"
        class="container__list--asset"
      >
        <span>{{ list.name }}</span>
        <li
          v-for="data in list.data"
          :key="data.name"
          class="fa-ul"
          @click="onSelectedAsset($event, list.name, data)"
          :class="{ available: userSelections.isClickAsset }"
        >
          {{ data.name }}
        </li>
      </ul>
    </section>
    <!-- Arrows -->
    <section class="container__arrow--assets flex-center-column">
      <article class="flex-center-column">
        <i
          class="pi pi-angle-right"
          @click="onSelectedAssetWithArrow()"
          :class="{ disabled: userSelections.arrowRDisabled }"
        ></i>
        <i
          class="pi pi-angle-left"
          @click="onSelectedAssetWithArrow()"
          :class="{ disabled: userSelections.arrowLDisabled }"
        ></i>
      </article>
      <article class="flex-center-column">
        <i
          class="pi pi-angle-double-right"
          :aria-disabled="false"
          @click="onSelectAllAssetsRight"
          :class="{ disabled: userSelections.arrowsRDisabled }"
        ></i>
        <i
          class="pi pi-angle-double-left"
          :aria-disabled="true"
          @click="onSelectAllAssetsLeft"
          :class="{ disabled: userSelections.arrowsLDisabled }"
        ></i>
      </article>
    </section>
    <!-- Selected assets -->
    <section class="col col 6 container__assets-selector">
      <div class="container__assets-selector--header">
        Selected assets
      </div>
      <section class="container__asset-selected">
        <template v-for="list in userSelections.allDataListSelected">
          <div
            v-for="data in list.data"
            :key="data.name"
            class="element__asset-selected d-flex"
          >
            <input
              type="radio"
              :id="data.name"
              name="asset"
              :value="data.name"
              @change="handleRadioChange(data.name)"
              checked
            />
            <label @click="onSelectedAsset($event, list.name, data)">{{
              data.name
            }}</label>
          </div>
        </template>
      </section>
    </section>
  </div>
</template>

<script>
import { select, selectAll } from "d3";

export default {
  name: "AssetSelector",
  props: {
    loadingAll: { required: true, type: Boolean },
    commodityList: { required: true, default: () => [] },
    currencyList: { required: true, default: () => [] },
    indexList: { required: true, default: () => [] },
    commodityDefs: { required: true, default: "na" }
  },
  data() {
    return {
      data: {
        allDataList: []
      },
      userSelections: {
        commodities: [],
        indexes: [],
        currencies: [],
        typeAsset: "",
        dataAsset: "",
        allDataListSelected: [],
        arrowRDisabled: true,
        arrowsRDisabled: false,
        arrowsLDisabled: false,
        arrowLDisabled: true,
        selectedAsset: null,
        isClickAsset: false
      }
    };
  },
  created() {
    this.addAllData();
  },
  watch: {
    commodityDefs() {
      this.addAllData();
    }
  },
  methods: {
    addAllData() {
      if (!this.loadingAll) {
        this.data.allDataList = [];
        this.userSelections.allDataListSelected = [];
        this.handleChangeCommodityDefs();

        const updatedCommodityList = this.commodityList.filter(
          item => item.name !== this.commodityDefs
        );
        this.orderData(updatedCommodityList);
        const updatedCurrencyList = this.currencyList.filter(
          item => item.name !== this.commodityDefs
        );
        this.orderData(updatedCurrencyList);

        const updatedIndexList = this.indexList.filter(
          item => item.name !== this.commodityDefs
        );
        this.orderData(updatedIndexList);

        this.data.allDataList.push({
          name: "Commodities",
          data: updatedCommodityList
        });
        this.data.allDataList.push({
          name: "Currencies",
          data: updatedCurrencyList
        });
        this.data.allDataList.push({ name: "Indexes", data: updatedIndexList });
        this.getStyleArrows();
      }
    },
    onSelectedAssetWithArrow() {
      const userSel = this.userSelections;
      const existingDataIndex = this.findDataIndex(
        userSel.allDataListSelected,
        userSel.typeAsset,
        userSel.dataAsset
      );
      const existTypeAssetSelect = this.findTypeAssetIndex(
        userSel.allDataListSelected,
        userSel.typeAsset
      );
      const existTypeAssetList = this.findTypeAssetIndex(
        this.data.allDataList,
        userSel.typeAsset
      );
      // Add data first time
      if (existingDataIndex === -1 && userSel.typeAsset) {
        this.handleListChange(userSel.dataAsset.name);

        const existingDataIdx = this.findTypeAssetIndex(
          this.data.allDataList,
          userSel.typeAsset
        );
        const dataIndexToDelete = this.findDataIndexInData(
          this.data.allDataList,
          existingDataIdx,
          userSel.dataAsset
        );
        const newData = {
          pk: userSel.dataAsset.pk,
          name: userSel.dataAsset.name
        };
        userSel.arrowRDisabled = false;
        userSel.arrowLDisabled = true;

        if (existTypeAssetSelect === -1) {
          userSel.allDataListSelected.push({
            name: userSel.typeAsset,
            data: [newData]
          });
        } else {
          userSel.allDataListSelected[existTypeAssetSelect].data.push(newData);
        }
        this.data.allDataList[existingDataIdx].data.splice(
          dataIndexToDelete,
          1
        );
      }
      // Add data if exist
      else if (userSel.typeAsset) {
        const checkedInput = document.querySelector(
          'input[type="radio"]:checked'
        );

        if (checkedInput && checkedInput.value === userSel.dataAsset.name) {
          this.handleListChange("");
        }
        const dataIndexToDelete = this.findDataIndexInData(
          userSel.allDataListSelected,
          existTypeAssetSelect,
          userSel.dataAsset
        );
        const newData = {
          pk: userSel.dataAsset.pk,
          name: userSel.dataAsset.name
        };

        userSel.arrowLDisabled = false;
        userSel.arrowRDisabled = true;

        if (existTypeAssetList === -1) {
          this.data.allDataList.push({
            name: userSel.typeAsset,
            data: [newData]
          });
        } else {
          this.data.allDataList[existTypeAssetList].data.push(newData);
          this.orderData(this.data.allDataList[existTypeAssetList].data);
        }
        // delete right
        userSel.allDataListSelected[existTypeAssetSelect].data.splice(
          dataIndexToDelete,
          1
        );
      }
      this.emitAssetsSelectedModel();
      this.getStyleArrows();
      userSel.typeAsset = "";
      userSel.dataAsset = "";
    },
    onSelectAllAssetsRight() {
      const userSel = this.userSelections;

      this.moveAllData(this.data.allDataList, userSel.allDataListSelected);
      this.data.allDataList = [];
      this.emitAssetsSelectedModel();
      setTimeout(() => {
        const checkedInput = document.querySelector(
          'input[type="radio"]:checked'
        );
        this.handleListChange(checkedInput.value);
      }, 0);
    },
    onSelectAllAssetsLeft() {
      const userSel = this.userSelections;

      this.moveAllData(
        userSel.allDataListSelected,
        this.data.allDataList,
        true
      );
      userSel.allDataListSelected = [];
      this.emitAssetsSelectedModel();
      this.handleListChange("");
    },
    handleRadioChange(assetName) {
      this.userSelections.selectedAsset = assetName;
      this.$emit("onShowForecastAssetSelected", assetName);
    },
    getStyleArrows() {
      const userSel = this.userSelections;
      if (userSel.allDataListSelected.length === 0) {
        userSel.arrowsRDisabled = false;
        userSel.arrowsLDisabled = true;
      }
      if (this.data.allDataList.length === 0) {
        userSel.arrowsLDisabled = false;
        userSel.arrowsRDisabled = true;
      }
      if (
        userSel.allDataListSelected.length > 0 &&
        this.data.allDataList.length > 0
      ) {
        userSel.arrowsLDisabled = false;
        userSel.arrowsRDisabled = false;
      }
    },
    handleListChange(name) {
      this.$emit("onShowForecastAssetSelected", name);
    },
    handleChangeCommodityDefs() {
      this.$emit("onShowForecastAssetSelected", "");
      this.$emit(
        "onAssetsSelectedModel",
        this.userSelections.allDataListSelected
      );
    },
    onSelectedAsset(event, typeAsset, dataAsset) {
      const userSel = this.userSelections;
      userSel.typeAsset = typeAsset;
      userSel.dataAsset = dataAsset;

      this.clearSelections();
      select(event.target).classed("available", true);

      const existingDataIndex = this.findDataIndex(
        userSel.allDataListSelected,
        typeAsset,
        dataAsset
      );

      userSel.arrowRDisabled = existingDataIndex !== -1;
      userSel.arrowLDisabled = existingDataIndex === -1;
    },
    findDataIndex(dataList, typeAsset, dataAsset) {
      return dataList
        .filter(d => d.name === typeAsset)
        .findIndex(obj => obj.data.some(d => d.pk === dataAsset.pk));
    },
    findTypeAssetIndex(dataList, typeAsset) {
      return dataList.findIndex(item => item.name === typeAsset);
    },
    findDataIndexInData(data, index, dataAsset) {
      return data[index].data.findIndex(d => d.pk === dataAsset.pk);
    },
    deleteData(data, idxData, idxDelete) {
      return data[idxData].data.splice(idxDelete, 1);
    },
    emitAssetsSelectedModel() {
      this.$emit(
        "onAssetsSelectedModel",
        this.userSelections.allDataListSelected
      );
    },
    orderData(dataToOrder) {
      return dataToOrder.sort((a, b) => a.name.localeCompare(b.name));
    },
    moveAllData(data, otherData, isOrder = false) {
      data.forEach(asset => {
        const existingDataIdx = this.findTypeAssetIndex(otherData, asset.name);
        if (existingDataIdx === -1) {
          otherData.push(asset);
        } else {
          otherData[existingDataIdx].data.push(...asset.data);
          if (isOrder) {
            this.orderData(this.data.allDataList[existingDataIdx].data);
          }
        }
      });
      this.getStyleArrows();
    },
    clearSelections() {
      selectAll(".fa-ul").classed("available", false);
      selectAll(".element__asset-selected label").classed("available", false);
    }
  },
  computed: {
    dataListAll() {
      return (
        this.commodityList.length === 0 &&
        this.currencyList.length === 0 &&
        this.indexList.length === 0
      );
    }
  }
};
</script>

<style scoped>
.container__assets-selector {
  height: calc(100% - 20px);
  margin: 10px 10px 10px;
  border: 1px solid var(--lightbackground);
  border-radius: 2px;
  overflow: hidden;
  max-width: 280px;
}
.container__assets-selector--header {
  height: 20px;
  border-bottom: 2px solid var(--lightbackground);
  color: var(--textinactive);
  background-color: var(--darkbackground3);
  padding: 0 5px;
}
.container__arrow--assets {
  height: 92%;
  margin: 30px 5px 0;
  position: relative;
}
.container__arrow--assets i {
  border: 1px solid;
  padding: 1px 5px;
  border-radius: 5px;
  cursor: pointer;
}
.container__arrow--assets article:first-child {
  position: absolute;
  gap: 5px;
  top: 40%;
}
.container__arrow--assets article:last-child {
  position: absolute;
  bottom: 3%;
  gap: 5px;
}
.element__asset-selected {
  border: 1px solid gray;
  padding-left: 5px;
  border-radius: 5px;
  max-width: 80%;
  margin: 8px auto;
  gap: 5px;
}
.element__asset-selected label {
  margin: 0;
}
.container__asset-selected {
  height: 95%;
  margin: 5px;
  overflow-y: auto;
}
.container__list--asset {
  height: 29%;
  overflow-y: auto;
  padding-left: 10px;
}
.container__assets-selector ul {
  margin: 5px 10px 1rem;
  border: 1px solid var(--lightbackground);
  border-radius: 2px;
}
.container__list--asset span {
  position: sticky;
  top: 0;
  background: var(--darkbackground);
  display: inline-block;
  width: 100%;
}
.container__list--asset li {
  border: 1px solid gray;
  padding-left: 5px;
  border-radius: 5px;
  max-width: 80%;
  margin: 8px auto;
}
@media (min-height: 800px) {
  .container__arrow--assets article:last-child {
    bottom: 2%;
  }
}
</style>
